module.exports = {
  SET_SNACKBAR: 'SET_SNACKBAR',
  RECEIVED_HOSTED_LINKS: 'RECEIVED_HOSTED_LINKS',
  SET_LOCAL_IPADDRESS: 'SET_LOCAL_IPADDRESS',
  SET_FIRST_LOGIN_AFTER_SIGNUP: 'SET_FIRST_LOGIN_AFTER_SIGNUP',
  PLANS: {
    os: 'Mender Starter',
    professional: 'Mender Professional',
    enterprise: 'Mender Enterprise'
  }
};
